module.exports = __webpack_public_path__ + "static/about_check_sp-e180372a7d421f965ce8b375f0e59ae9.jpg";